import { useCallback } from "react";
import { useUserPrefs } from "@/lib/stores/user-prefs";
import { usePlayBundledSoundsAction } from "./use-play-sound";

const SUCCESS_SOUND_BASE_FILE_NAME = "SYSTEM_SUCCESS";

export const usePlaySuccessSoundIfEnabled = () => {
  const prefs = useUserPrefs();
  const playSuccess = usePlayBundledSoundsAction([
    SUCCESS_SOUND_BASE_FILE_NAME,
  ]);

  return useCallback(() => {
    if (prefs?.successSoundEnabled) {
      playSuccess();
    }
  }, [prefs?.successSoundEnabled, playSuccess]);
};
